import React from "react";
import PropTypes from "prop-types";

import { cachingRefetchWithToken } from "../netzwerk/Refetch";

class Errorlog extends React.Component {
	
	static propTypes = {
		auth: PropTypes.object.isRequired
	};

	render() {
		return (
			<div className="Errorlog">
			</div>
		);
	}
}

export default cachingRefetchWithToken(() => ({
}))(Errorlog);
